import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigService } from 'src/app/services/config.service';
import { AlertService } from '../../shared/alert/alert.service';
@Component({
  selector: 'app-inventory-adjustment-popup',
  templateUrl: './inventory-adjustment-popup.component.html',
  styleUrls: ['./inventory-adjustment-popup.component.scss']
})
export class InventoryAdjustmentPopupComponent implements OnInit {
 constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<InventoryAdjustmentPopupComponent>,
    private service: ConfigService,
    public alert: AlertService,
    private ngxLoader: NgxUiLoaderService) { }

    columnsToDisplay = [

      {
        displayName: 'Line No',
        field: 'line_no',
        isVisible: true,
        isDragable: false,
        align: 'text-start',
        stiky: 'Start',
        StickyIndex: 0,
        clickable: false,
        detailViewActionButton: false,
        allowtohide: false,
        left: true
      },
      {
        displayName: 'SKU',
        field: 'sku',
        fieldprd_img: 'sku_image',
        fieldprd_sku: 'sku',
        isVisible: true,
        isDragable: true,
        align: 'text-left',
        allowtohide: false,
      },
      {
        displayName: 'Location',
        field: 'location_name',
        isVisible: true,
        isDragable: true,
        align: 'text-center',
        allowtohide: false,
      },
      {
        displayName: 'Previous Qty',
        field: 'previous_qty',
        fieldprd_sku: 'product_name',
        isVisible: true,
        isDragable: true,
        align: 'text-start',
        allowtohide: false,
        left: true,
        isDecimalDisplay: true
      },
      {
        displayName: 'Discrepancy',
        field: 'discrepancy',
        isVisible: true,
        isDragable: true,
        align: 'text-center',
        allowtohide: false,
      },
      {
        displayName: 'Updated Qty',
        field: 'updated_qty',
        isVisible: true,
        isDragable: true,
        align: 'text-center',
        allowtohide: false,
        isDecimalDisplay: true
      },
      {
        displayName: 'Updated At',
        field: 'updated_at',
        isVisible: true,
        isDragable: true,
        align: 'text-center',
        allowtohide: false,
      },
      {
        displayName: 'Updated By',
        field: 'updated_by',
        isVisible: true,
        isDragable: true,
        align: 'text-center',
        allowtohide: false,
      },

    ];
  ngOnInit(): void {
    // this.viewInventoryAdjustment()
  }

  closeDialog() {
    this.dialogRef.close();
  }
  // async viewInventoryAdjustment() {

  //   this.ngxLoader.start();

  //   let url =this.data?.apiURL;

  //   const response = await this.service.getApi(
  //     url,
  //     {})

  //   if (response?.success && response?.data) {
  //     this.data.gridData = response?.data;
  //   } else {
  //     this.alert.show(response?.error?.message, "error")
  //   }
  //   this.ngxLoader.stop();
  // }
}
